/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
window.Vue = require('vue');
require('../attachApiTokenHeader').rememberApiTokenFromComponent(window.Vue);

/* Components Javascript Import*/
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Optionally install the BootstrapVue icon components plugin
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.component(
    'lesson-chat-history-viewer-component',
    require('./components/shared/LessonChatHistoryViewerComponent.vue').default
);

//css
//import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'


let pathname = window.location.pathname
let url = pathname.split("/");

if (url[1] === 'admin') {

    //administration
    switch (url[2]) {
        case '':
        case 'dashboard':
        case 'lesson':
            Vue.component('schedule-item-component', require('./components/ScheduleItemComponent.vue').default);
            break;
        case 'member':
            if (url[4] === 'edit') {
                console.log("load edit member!")
                Vue.component('member-update-component', require('./components/MemberUpdateComponent.vue').default);
                Vue.component('member-multiaccount-update', require('./components/backend/member/MemberMultiAccountUpdateComponent.vue').default);
                
            } else {

                Vue.component('member-create-component', require('./components/MemberCreateComponent.vue').default);
            }

            //MEMBER INFO PAGE:  @url: member/{$id}
            if (url[3]) {
                Vue.component('member-score-component', require('./components/backend/member/MemberScoreViewerComponent.vue').default);
                Vue.component('member-purpose-viewer-component', require('./components/backend/member/MemberPurposeViewerComponent.vue').default);
                Vue.component('member-notes-component', require('./components/backend/member/MemberNotesComponent.vue').default);
                Vue.component('member-time-manager-viewer-component', require('./components/backend/member/MemberTimeManagerViewerComponent.vue').default);
                Vue.component('member-mini-test-viewer-component', require('./components/backend/member/MemberMiniTestViewerComponent.vue').default);
                Vue.component('report-card-viewer-component', require('./components/backend/member/ReportCardViewerComponent.vue').default) 
            }
            break;
        case 'reportcard':
            Vue.component('member-notes-component', require('./components/backend/member/MemberNotesComponent.vue').default);
            break;
        case 'customerchatsupport':
            Vue.component('admin-chat-component', require('./components/AdminChatComponent.vue').default);
            break;
        default:
            console.log("admin default page loaded")
            Vue.component('schedule-item-component', require('./components/ScheduleItemComponent.vue').default);   
    }

    //AGENT
    Vue.component('agent-calendar-component', require('./components/backend/agent/AgentCalendarViewerComponent.vue').default);    

    Vue.component('agent-member-registration-component', require('./components/backend/agent/AgentMemberRegistrationComponent.vue').default);     

    Vue.component('agent-buy-credit-component', require('./components/backend/agent/AgentBuyCreditComponent.vue').default);    
    Vue.component('agent-member-main-menu-component', require('./components/backend/agent/AgentMemberMainMenuComponent.vue').default);    
    Vue.component('agent-member-transaction-history-component', require('./components/backend/agent/AgentMemberTransactionHistoryComponent.vue').default);    

    Vue.component('agent-calendar-reservation-component', require('./components/backend/agent/AgentCalendarReservationComponent.vue').default);    
    Vue.component('agent-fix-reserve-component', require('./components/backend/agent/AgentFixReserveComponent.vue').default);    


    Vue.component('agent-chat-component', require('./components/backend/agent/AgentChatSupportComponent.vue').default);    
   

} else {

    Vue.component('member-purpose-component', require('./components/frontend/member/MemberPurposeComponent.vue').default)
    Vue.component('member-score-component', require('./components/frontend/member/MemberScoreComponent.vue').default);
    Vue.component('member-level-component', require('./components/frontend/member/MemberLevelComponent.vue').default);
    Vue.component('member-time-manager-component', require('./components/frontend/member/MemberTimeManagerComponent.vue').default);
    Vue.component('member-account-merger-component', require('./components/frontend/member/MemberAccountMergerComponent.vue').default);
    Vue.component('questions-component', require('./components/frontend/member/QuestionsComponent.vue').default);
    Vue.component('questions-multi-answers-component', require('./components/frontend/member/QuestionsMultiAnswersComponent.vue').default);

    //Vue.component('simple-uploader-component', require('./components/SimpleUploaderComponent.vue').default);

    Vue.component('member-mutliaccount-component', require('./components/frontend/member/MemberMultiAccountComponent.vue').default)
    Vue.component('member-lessonviewer-component', require('./components/frontend/member/MemberLessonViewerComponent.vue').default)
    
    Vue.component('star-rating-pending-list-component', require('./components/frontend/member/getStarRatingPendingListComponent.vue').default)
    
    //front end 
    switch (url[1]) {
        case 'customerchatsupport':
            //this is for front end dedicated page (cancelled project)
            //Vue.component('customer-chat-component', require('./components/frontend/chat/CustomerChatComponent.vue').default);
            break;
        default:
            Vue.component('member-floating-chat-component', require('./components/frontend/chat/MemberFloatingChatComponent.vue').default);
            //console.log("default front end")
    }
}

Vue.component('lesson-selector-component', require('./components/frontend/member/LessonSelectorComponent.vue').default);
//Vue.component('new-lesson-slide-selector-component', require('./components/frontend/member/NewLessonSlideSelectorComponent.vue').default);

Vue.component('lesson-slider-component', require('./components/frontend/member/MemberLessonSliderComponent.vue').default);
Vue.component('lesson-slider-chatroom-component', require('./components/frontend/member/MemberLessonSliderChatroomComponent.vue').default);
Vue.component('member-caller-component', require('./components/frontend/member/MemberCallerComponent.vue').default);

// MyRoom incoming-call popup — same component MyPage members use (shared source).
Vue.component('incoming-call-component', require('../components/IncomingCallComponent.vue').default);

Vue.component('lesson-viewer-component', require('./components/frontend/member/LessonSlideViewerComponent.vue').default);
Vue.component('lesson-chat-viewer-component', require('./components/frontend/member/LessonSlideChatViewerComponent.vue').default);

Vue.component('member-com-editor-component', require('./components/frontend/member/memberComEditorComponent.vue').default);


Vue.component('debug-chat-component', require('./components/frontend/chat/debugChatComponent.vue').default)


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

//const files = require.context('./', true, /\.vue$/i)
//files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


//Vue.component('example-component', require('./components/ExampleComponent.vue').default);
//Vue.component('file-upload', VueUploadComponent);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.filter('formatSize', function(size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
    }
    return size + ' B'
})

const app = new Vue({
    el: '#app',
    components: {
        //draggable: window['vuedraggable'],
        //VueUploadComponent: window['vue-upload-component']
    },
});


/* non-render blocking css files */
var deferCSS = [];
deferCSS.push(
    //"//fonts.googleapis.com/css?family=Nunito&display=swap",
    //window.location.protocol + "//" + window.location.host + "/css/app.css"
);